module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-how-we-teach-5f2059be8c3518a6278d5e5303a25185.png";